export const phoneNumberCountryCodes = [
    { country: "Hongkong", code: "+852" },
    { country: "China", code: "+86" },
    { country: "Japan", code: "+81" },
    { country: "Korea", code: "+82" },
];

export const emptyChildForm = {
    firstName: "",
    lastName: "",
    hoursLeft: "",
    age: "",
    email: "",
};

export const initialState = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address: "",
    membershipType: "",
    phoneNumberCountryCode: "",
    password: undefined,
    active: undefined,
};

export const columns = [
    {
        id: "transactionDate",
        Header: "Transaction Date",
        accessor: (row) => {
            return new Date(row.createdAt).toLocaleString();
        },
        sortable: true,
        filterable: true,
    },
    {
        id: "itemsOrdered",
        Header: "Items Ordered",
        accessor: (row) => {
            return row.menuItemName || row.menuItem?.titleEn;
        },
        sortable: true,
        filterable: true,
    },
    {
        id: "quantity",
        Header: "Quantity",
        accessor: (row) => {
            return row.quantity;
        },
        sortable: true,
    },
    {
        id: "totalAmount",
        Header: "Total Amount",
        accessor: (row) => {
            if (isNaN(parseFloat(row.totalTransactionPrice)))
                return parseInt(row.menuItem?.price) * parseInt(row.quantity);
            return parseFloat(row.totalTransactionPrice).toFixed(2);
        },
    },
];

export const membershipColumns = [
    {
        id: "memberId",
        Header: "Member ID",
        accessor: "id",
        sortable: true,
        filterable: true,
    },
    {
        id: "active",
        Header: "Active",
        accessor: (row) =>
            row.active ? (
                <span className="text-success">Yes</span>
            ) : (
                <span className="text-danger">No</span>
            ),
        filter: (rows, columnIds, filterValue) => {
            if (filterValue === "all") return rows;
            return rows.filter(
                (row) => JSON.stringify(row.original.active) === filterValue
            );
        },
        Filter: ({ setFilter, column }) => (
            <select
                className="form-control"
                onChange={(event) => setFilter(column.id, event.target.value)}
                onClick={(e) => e.stopPropagation()}
            >
                <option value="all">All</option>
                {[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ].map(({ value, label }) => (
                    <option value={value} key={value}>
                        {label}
                    </option>
                ))}
            </select>
        ),
        filterable: true,
    },
    {
        id: "firstname",
        Header: "First Name",
        accessor: "firstName",
        sortable: true,
        filterable: true,
    },
    {
        id: "lastName",
        Header: "Last Name",
        accessor: "lastName",
        sortable: true,
        filterable: true,
    },
    {
        id: "phoneNumber",
        Header: "phoneNumber",
        accessor: (row) =>
            `${
                row.phoneNumberCountryCode ? row.phoneNumberCountryCode : "+852"
            }-${row.phoneNumber}`,
        sortable: true,
        filterable: true,
    },
    {
        id: "email",
        Header: "Email",
        accessor: "email",
        sortable: true,
        filterable: true,
    },
    {
        id: "type",
        Header: "Type",
        accessor: "membershipType",
        sortable: true,
        filterable: true,
    },
    {
        id: "points",
        Header: "Points",
        accessor: "membershipPoints",
        sortable: true,
        filterable: true,
    },
    {
        id: "actions",
        Header: "actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
    },
];

export const addPointsRecordsColumns = [
    {
        id: "orderDate",
        Header: "Order Date",
        accessor: (row) => {
            return new Date(row.createdAt).toLocaleString();
        },
        sortable: true,
        filterable: true,
    },
    {
        id: "recordID",
        Header: "Record ID",
        accessor: "id",
        sortable: true,
        filterable: true,
    },
    // {
    //     id: "user",
    //     Header: "Member Name",
    //     accessor: (row) => `${row.user.firstName} ${row.user.lastName}`,
    //     sortable: true,
    //     filterable: true,
    // },
    {
        id: "pointsAdded",
        Header: "Points Added",
        accessor: "membershipPoints",
        sortable: true,
        filterable: true,
    },
    {
        id: "paymentMethod",
        Header: "Payment Method",
        accessor: (row) => row.paymentMethod,
        sortable: true,
        filterable: true,
    },
    {
        id: "uploaded",
        Header: "Uploaded Receipt",
        accessor: (row) => (
            <div
                className={`${
                    row.invoiceImgPath ? "text-success" : "text-danger"
                }`}
            >
                {row.invoiceImgPath ? "Yes" : "No"}
            </div>
        ),
        sortable: true,
        filterable: true,
    },
    {
        id: "actions",
        Header: "actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
    },
];

export const phoneNumberCountryCodeOptions = phoneNumberCountryCodes.map(
    (phoneNumberCountryCode) => ({
        value: phoneNumberCountryCode.code,
        label: `${phoneNumberCountryCode.country} (${phoneNumberCountryCode.code})`,
    })
);

export const initialAddPointsRecordState = {
    membershipPoints: 0,
    invoiceImgPath: "",
    paymentMethod: "",
};
